module.exports = __webpack_public_path__ + "img/mobilpark-logo.6dc1b831.svg";